import { Link } from "react-router-dom";
import { ContactUs } from "../../../../models";
import IconButton from "../../../../components/icon-button";
import { PencilIcon } from "@heroicons/react/24/outline";

export function UpdateButton({id}:{id?:string}){
    return  <Link to={`/admin/contact-us/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
}
